<template>
    <div>
        <el-dialog title="配煤结果" style="text-align:center" :visible="visible" :show="show" width="85%"      @close="close" :close-on-click-modal="false">
            <!--<el-descriptions class="margin-top" title="配煤结果参数" :column="5" :size="size" border>
                <el-descriptions-item>
                    <template slot="label">
                        热值：
                    </template>
                    <span>{{rowData.targetHots}}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        硫分：
                    </template>
                    <span>{{rowData.targetLiufen}}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        发运量：
                    </template>
                    <span>{{rowData.totalCount}}</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        一票含税到场价：
                    </template>
                    {{baseDataMap.resultPriceTax}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        到场地：
                    </template>
                    {{baseDataMap.arrtiveStation}}
                </el-descriptions-item>
                &lt;!&ndash;含税比例部分&ndash;&gt;
                <el-descriptions-item>
                    <template slot="label">
                        合计含税占用资金：
                    </template>
                    <el-tag size="small">{{baseDataMap.totaPriceTax}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        煤款含税占用资金：
                    </template>
                    <el-tag size="small">{{baseDataMap.CoaltotUnitPrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        运费含税占用资金：
                    </template>
                    <el-tag size="small">{{baseDataMap.CoaltotFreightTax}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        单吨价格：
                    </template>
                    <el-tag size="small">{{baseDataMap.resultPriceTax}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        单卡价：
                    </template>
                    <el-tag size="small">{{baseDataMap.hsDkj}}</el-tag>
                </el-descriptions-item>

                &lt;!&ndash;不含税比例&ndash;&gt;
                <el-descriptions-item>
                    <template slot="label">
                        合计不含税占用资金
                    </template>
                    <el-tag size="small">{{baseDataMap.totalPrice}}</el-tag>

                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        煤款不含税占用资金：
                    </template>
                    <el-tag size="small">{{baseDataMap.bhsCoaltotUnitPrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        运费不含税占用资金：
                    </template>
                    <el-tag size="small">{{baseDataMap.coaltotFreight}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        单吨价格：
                    </template>
                    <el-tag size="small">{{baseDataMap.resutPrice}}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        单卡价：
                    </template>
                    <el-tag size="small">{{baseDataMap.bhsDkj}}</el-tag>
                </el-descriptions-item>


            </el-descriptions>-->

            <el-table :data="dataList" border style="width: 100%" height="500px">
                <el-table-column type="expand" >
                    <template slot-scope="scope">
                        <el-descriptions class="margin-top" title="配煤结果参数" :column="5" :size="size" border>
                            <el-descriptions-item>
                                <template slot="label">
                                    热值：
                                </template>
                                <span>{{baseDataList[scope.$index].expressionHots}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    硫分：
                                </template>
                                <span>{{scope.row.liufenResult}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    发运量：
                                </template>
                                <span>{{rowData.totalCount}}</span>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    一票含税到场价：
                                </template>
                                {{scope.row.resultPrice}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    到场地：
                                </template>
                                {{rowData.arrtiveStation}}
                            </el-descriptions-item>
                            含税比例部分
                            <el-descriptions-item>
                                <template slot="label">
                                    合计含税占用资金：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].totaPriceTax}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    煤款含税占用资金：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].CoaltotUnitPrice}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    运费含税占用资金：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].CoaltotFreightTax}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    单吨价格：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].resultPriceTax}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    单卡价：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].hsDkj}}</el-tag>
                            </el-descriptions-item>

                            &lt;!&ndash;不含税比例&ndash;&gt;
                            <el-descriptions-item>
                                <template slot="label">
                                    合计不含税占用资金
                                </template>
                                <el-tag >{{baseDataList[scope.$index].totalPrice}}</el-tag>

                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    煤款不含税占用资金：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].bhsCoaltotUnitPrice}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    运费不含税占用资金：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].coaltotFreight}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    单吨价格：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].resutPrice}}</el-tag>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    单卡价：
                                </template>
                                <el-tag >{{baseDataList[scope.$index].bhsDkj}}</el-tag>
                            </el-descriptions-item>


                        </el-descriptions>
                    </template>
                </el-table-column>
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column label="煤源1/占比/热值" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId1!=0" @click="openCocalDetail(scope.row.cocalId1,1)" style="color:blue;cursor:pointer"> {{scope.row.cocalName1}}/{{scope.row.weight1}}%/{{scope.row.hots1}} </span>
                        <span v-else>未参与配煤</span>

                    </template>
                </el-table-column>
                <el-table-column label="煤源2/占比/热值" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId2!=0" @click="openCocalDetail(scope.row.cocalId2,2)" style="color:blue;cursor:pointer"> {{scope.row.cocalName2}}/{{scope.row.weight2}}%/{{scope.row.hots2}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源3/占比/热值" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId3!=0" @click="openCocalDetail(scope.row.cocalId3,3)" style="color:blue;cursor:pointer"> {{scope.row.cocalName3}}/{{scope.row.weight3}}%/{{scope.row.hots3}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源4/占比/热值" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId4!=0" @click="openCocalDetail(scope.row.cocalId4,4)" style="color:blue;cursor:pointer"> {{scope.row.cocalName4}}/{{scope.row.weight4}}%/{{scope.row.hots4}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="煤源5/占比/热值" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.cocalId5!=0" @click="openCocalDetail(scope.row.cocalId5,5)" style="color:blue;cursor:pointer"> {{scope.row.cocalName5}}/{{scope.row.weight5}}%/{{scope.row.hots5}}</span>
                        <span v-else>未参与配煤</span>
                    </template>
                </el-table-column>
                <el-table-column label="配煤热值" align="center" width="80" prop="expressionHots"></el-table-column>
                <el-table-column label="配煤硫分值" align="center" width="80" prop="liufenResult"></el-table-column>
                <el-table-column label="配煤价格" align="center" width="80" prop="resultPrice"></el-table-column>
                <el-table-column label="优先级" align="center" width="80" prop="sort"></el-table-column>
            </el-table>
            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-dialog>
        <!--煤源煤炭明细页面-->
        <el-dialog title="煤种数据" style="text-align:center" :visible="cocalDetailVisible" :show="show" width="70%" :close-on-click-modal="false"
                   @close="cocalDetailVisible=false">
            <div style="height:200px;width:100%;">
                <div id="coalEcharts" style="width:auto;height:100%"></div>
            </div>

            <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" label-width="140px" v-if="ruleForm.proName!=null">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="煤炭名称" class="input" prop="proName" >
                            <el-input v-model="ruleForm.proName" autocomplete="off" placeholder="煤炭名称"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="联系人" class="input" prop="linkmanMine" >
                            <el-input v-model="ruleForm.linkmanMine" autocomplete="off" placeholder="联系人"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="联系电话" class="input" prop="phoneMine" >
                            <el-input v-model="ruleForm.phoneMine" autocomplete="off" placeholder="联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :span="6">
                        <el-form-item label="提煤联系人1" class="input" prop="linkmanTimei1" >
                            <el-input v-model="ruleForm.linkmanTimei1" autocomplete="off" placeholder="提煤联系人1"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="提煤联系人1电话" class="input" prop="phoneTimei1" >
                            <el-input v-model="ruleForm.phoneTimei1" autocomplete="off" placeholder="提煤联系人1电话"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="提煤联系人2" class="input" prop="linkmanTimei2" >
                            <el-input v-model="ruleForm.linkmanTimei2" autocomplete="off" placeholder="提煤联系人2"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="提煤联系人2电话" class="input" prop="phoneTimei2" >
                            <el-input v-model="ruleForm.phoneTimei2" autocomplete="off" placeholder="提煤联系人2电话"></el-input>
                        </el-form-item>
                    </el-col>

                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="煤种类型" class="input" prop="coalType" >
                            <el-input v-model="ruleForm.coalType" autocomplete="off" placeholder="煤种类型"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="硫分" class="input" prop="liufen" >
                            <el-input v-model="ruleForm.rawLiufen" autocomplete="off" placeholder="硫分"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="热值" class="input" prop="coalHeat" >
                            <el-input v-model="ruleForm.coalHeat" autocomplete="off" placeholder="热值"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="是否破碎" class="input" prop="isBroken" >
                            <el-select v-model="ruleForm.isBroken" style="width:80%">
                                <el-option label="是" value="是"></el-option>
                                <el-option label="否" value="否"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="破碎费用" class="input" prop="brokenPrice" >
                            <el-input v-model="ruleForm.brokenPrice" autocomplete="off" placeholder="破碎费用"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="降热值" class="input" prop="fallHots" >
                            <el-input v-model="ruleForm.fallHots" autocomplete="off" placeholder="降热值"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="全水" class="input" prop="rawShuifen" >
                            <el-input v-model="ruleForm.rawShuifen" autocomplete="off" placeholder="全水"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="收到基灰分" class="input" prop="rawHuifafen" >
                            <el-input v-model="ruleForm.rawHuifafen" autocomplete="off" placeholder="收到基灰分"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="焦渣特征" class="input" prop="rawJiaoza" >
                            <el-input v-model="ruleForm.rawJiaoza" autocomplete="off" placeholder="焦渣特征"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="空气干燥基固定碳" class="input" prop="rawGudingtan" >
                            <el-input v-model="ruleForm.rawGudingtan" autocomplete="off" placeholder="空气干燥基固定碳"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="空气干燥基挥发分" class="input" prop="rawHuifafen" >
                            <el-input v-model="ruleForm.rawHuifafen" autocomplete="off" placeholder="空气干燥基挥发分"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="含税单价" class="input" prop="unitPrice" >
                            <el-input v-model="ruleForm.unitPrice" autocomplete="off" placeholder="含税单价"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="库存" class="input" prop="coalInventory" >
                            <el-input v-model="ruleForm.coalInventory" autocomplete="off" placeholder="库存"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="到场地" class="input" prop="arrtiveStation" >
                            <el-input v-model="ruleForm.arrtiveStation" autocomplete="off" placeholder="到场地"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="6">
                        <el-form-item label="含税运费" class="input" prop="freightTax" >
                            <el-input v-model="ruleForm.freightTax" autocomplete="off" placeholder="含税运费"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="6">
                        <el-form-item label="不含税运费" class="input" prop="freight" >
                            <el-input v-model="ruleForm.freight" autocomplete="off" placeholder="不含税运费"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="场地费" class="input" prop="stationPrice" >
                            <el-input v-model="ruleForm.stationPrice" autocomplete="off" placeholder="场地费"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
                    <el-button class="btn close" @click="cocalDetailVisible=false">取消</el-button>
                </div>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    export default{
        name:'coalMatchDetail',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                }
            },
            rowData(){
                if (this.show){
                    this.getCocalMatchList();
                }
            },
        },
        data(){
            return{
                visible:false,
                dataList:[],
                cocalDetailVisible:false,
                ruleForm:{},
                baseDataMap:{},
                size:'',
                baseDataList:[],
            }
        },
        methods:{
            close(){
                this.dataList = [];
                this.$emit("listenToChildEvent",false);
            },
            getCocalMatchList(){
                this.$http({
                    url: "wxApi/coalMatchResult/info/"+this.rowData.id,
                    method: "get",
                }).then(({data}) => {
//                    console.log(data);
//                    this.baseDataMap = data.baseDataMap;
//                    this.baseDataMap.stationPrice = data.coalStation.stationPrice;
                    this.dataList = data.cocalMatchList;
                    for (let i = 0 ; i < this.dataList.length;i++){
                        this.getCoalDetail(i);
                    }
                });
            },
            getCoalDetail(index){
                this.$http({
                    url: "wxApi/coalMatchResult/getMatchListByParams/"+this.rowData.id+"/"+index,
                    method: "get",
                }).then(({data}) => {
//                    console.log(data);
//                    this.baseDataMap = data.baseDataMap;
                    this.baseDataList.splice(index,0,data.baseDataMap);
//                    this.baseDataMap.stationPrice = data.coalStation.stationPrice;
//                    this.dataList = data.cocalMatchList;
                });
            },

            openCocalDetail(id,index){
                this.$http({
                    url: "wxApi/coalProduct/info/"+id,
                    method: "get",
                }).then(({data}) => {
                    this.ruleForm = data.data;
                    this.ruleForm.arrtiveStation = this.baseDataMap.arrtiveStation;
                    this.ruleForm.freight =this.baseDataMap['freight'+index];
                    this.ruleForm.freightTax =this.baseDataMap['freightTax'+index];
                    this.ruleForm.stationPrice =this.baseDataMap['stationPrice'];
                    this.cocalDetailVisible = true;
                    let xAxis = data.xAxis;
                    let yAxis = data.yAxis;
                    setTimeout(()=>{
                        this.homeChart(xAxis,yAxis);
                    }, 1000 )
                });
            },
            homeChart(xAxis,yAxis) {
                // 基于准备好的dom，初始化echarts实例
                var myChart = this.$echarts.init(document.getElementById("coalEcharts"));
                // 指定图表的配置项和数据
                var option = {
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        data: ["价格"]
                    },

                    xAxis: {
                        type: "category",
                        boundaryGap: false,
                        data: xAxis,
                        name:'日期'
                    },
                    yAxis: {
                        type: "value",
                        name:'价格',
                        interval: 150
                    },
                    series: [
                        {
                            name: "价格",
                            type: "line",
                            stack: "总量",
                            data: yAxis
                        }
                    ]
                };
                // // 使用刚指定的配置项和数据显示图表。
                myChart.setOption(option);
                //根据窗口的大小变动图表
                window.onresize = function() {
                    myChart.resize();
                };
            }


        }
    }
</script>